<template>
  <div class="box2">
    <pageTitle
      title="学鸿蒙 稳站风口"
      text="把握科技变革机遇，引领未来智能生态潮流"
      titleColor="#000D4D"
      titColor="#5A628A"
    />

    <div class="subject-box">
      <div class="nav-box">
        <div class="nav"
          :class="{ 'cur-nav': cur == index }" 
          v-for="(item, index) in navList" 
          :key="index"
          @click="changeCur(index)">
          <p>{{item.name}}</p>
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems" :class="{'trans': cur === 1}">
        <swiper-slide class="swiperwrap">
          <div class="item-wrapper">
						<div class="item">
							<div class="sub-title">
								<p>就业市场缺口巨大</p>
								<p>企业争签<span class="hot">定向输送</span>战略</p>
							</div>
							<div class="img">
								<img src="../../../assets/coursePage/harmony/box2/pic1.png" alt="" />
							</div>
						</div>
						<div class="seek-btn" @click="openDetail('抢占学习名额')">
							抢占学习名额
						</div>
					</div>
        </swiper-slide>
        <swiper-slide class="swiperwrap">
          <div class="item-wrapper">
						<div class="item">
							<div class="sub-title">
								<p>鸿蒙装机量已超<span class="hot">10亿</span></p>
								<p><span class="hot">18</span>个领域<span class="hot">10万+</span>App开发将在25年完成</p>
							</div>
							<div class="img img2">
								<img src="../../../assets/coursePage/harmony/box2/pic2.png" alt="" />
							</div>
						</div>
						<div class="seek-btn" @click="openDetail('了解鸿蒙生态')">
							了解鸿蒙生态
						</div>
					</div>	
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import check from "../../../utils/check";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    let that = this;
    return {
      navList: [
        { name: "人才输出战略" },
        { name: "鸿蒙生态爆发" },
      ],
      cur: 0,
      swiperOption: {
        loop: false,
        spaceBetween: 20,
        slidesPerView: "auto",
        centeredSlides: true,
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
          }
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
    openDetail(name) {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
         this.clickZiXun()
      }
      this.mai("鸿蒙-就业课",name,0,null)
    },
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 80px 0 0;
  width: 100%;
  background: url("../../../assets/coursePage/harmony/box2/bg.png") no-repeat;
  background-size: 100% auto;
  font-family: PingFang SC;
  .subject-box {
    position: relative;
    margin: 40px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .nav-box {
      margin: 0 auto;
      width: 500px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .nav {
        p {
          padding: 20px 0;
          width: 200px;
          font-weight: 600;
          font-size: 28px;
          color: #000D4D;
          line-height: 28px;
          text-align: center;
        }
      }
      .cur-nav {
        p {
          color: #002BFF;
          position: relative;
          &::before {
            content: "";
            position: absolute;
            left: 0; 
            right: 0;
            bottom: 0;
            margin: 0 auto;
            width: 130px;
            height: 4px;
            background: #002BFF;
          }
          &::after {
            z-index: 100;
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: -10px;
            margin: 0 auto;
            width: 0;
            height: 0;
            border-left: 10px solid transparent; // 左边框宽度为 10px，透明色
            border-right: 10px solid transparent; // 右边框宽度为 10px，透明色
            border-top: 10px solid #002BFF;
          }
        }
      }
    }
  }
  .swiperitems {
    background: #E6E9FA;
    padding: 40px 30px 80px 0;
  }
  .trans {
    ::v-deep.swiper-wrapper {
      transform: translate3d(-640px, 0px, 0px) !important;
    }
  }
  .swiper-slide {
    width: 660px;
  }

 
  .item-wrapper{
    .item{
      padding: 40px 0;
      background: #FFFFFF;
      border-radius: 30px;
      .sub-title {
        font-weight: 600;
        font-size: 36px;
        color: #000D4D;
        line-height: 54px;
        text-align: center;
        span {
          color: #002BFF;
        }
      }
      .img{
        margin-top: 70px;
        padding: 0 35px;
        img{
          display: block;
          width: 100%;
        }
      }
      .img2 {
        margin-top: 54px;
      }
    }
    .seek-btn {
      margin: 50px auto 0;
      width: 590px;
      height: 88px;
      background: linear-gradient(0deg, #FF6C47 1%, #FF5A47 100%);
      border-radius: 44px;
      font-weight: 600;
      font-size: 30px;
      color: #FFFFFF;
      line-height: 88px;
      text-align: center;
    }
  } 
}
</style>
